/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  place-order-request-reducer.tsx
 *
 * Project Title :  Checkout
 *
 * Description	 :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Grandhi Srinivas (E528634)
 *
 * @Date		 : Sep 12, 2019
 *
 * @Version      : Version 1.0
 * 
 * By            : Grandhi Srinivas (E528634)
 * On            : Oct 09, 2019
 * Description   : Updated code as per ASDS-1301. 
 * 
 * By            : H224423
 * On            : Dec 09 2019
 * Description   : ASDS-1814 - Place order redirection changes
 *
 * By            : Srinivas Grandhi (E528634)
 * On            : Jan 06,2020
 * Description   : updated code as per ASDS-1764.
 * 
 * By            : Deepthi Bachu(E844276)
 * On            : Jan 28, 2020
 * Description   : ASDS-2048 - Admin Functionality
 * 
 * By            : Deepthi Bachu - E844276
 * On            : 04 Mar, 2020
 * Description   : ASDS-2409 - NGBSS place order service - address parameter changes
 ******************************************************************************/

import Reducer from './reducer';
import { AsdsReduxAction, AsdsReducerObject } from '../../../../../types';
import CheckoutActionConstants from "../action-constants";
import { createReducer } from "../utils/redux-util";

class PlaceOrderRequestReducer extends Reducer {

    /**
     * ASDS-1169
     * @description: This method is to save order response in store
     * @param state
     * @param {AsdsReduxAction} action
     * @returns {AsdsReducerObject}
     */
    static placeOrderRequest(state, action: AsdsReduxAction): AsdsReducerObject {

        const orderNo: string = action.payload.orderReference.results.orderNo;
        const status: string = action.payload.orderReference.status;

        return {
            isSuccess: true,
            isFetching: false,
            payload: {
                ...state.payload,
                orderReference: {
                    status: status,
                    orderNo: orderNo,
                },
                isOrderRequestInProgress: false,
            }
        }
    }

    static dispatchPlaceOrderProcessing(state, action: AsdsReduxAction): AsdsReducerObject {
        return {
            isSuccess: true,
            isFetching: false,
            payload: {
                ...state.payload,
                isOrderRequestInProgress: action.payload.isOrderRequestInProgress,
            }
        }
    }

    static resetPlaceOrderObj(state) {
        return {
            payload: {
                ...state.payload,
                orderObj:{
                    soldTo: '',
                    shipTo: '',
                    userId: '',
                    paymentTerm:'',
                    accountId:'',
                    soldToAddressId:'',
                    shipToAddressId:'',
                    creditCard:{
                        cardType: '',
                        validTo: '',
                        cardHolderName: '',
                        cardToken: ''
                    },
                    purchaseOrder:{
                        poNumber: '',
                        poDate: '',
                        poDocument: '',
                        poFileName: '',
                        poContentType: 'application/pdf'
                    },
                    system: '',
                    emailIds: [''],
                    products: []
                }
            }
        }
    }

}

const handlers = {
    [CheckoutActionConstants.PLACE_ORDER_REQUEST]: PlaceOrderRequestReducer.placeOrderRequest,
    [CheckoutActionConstants.PLACE_ORDER_REQUEST_PROCESSING]: PlaceOrderRequestReducer.dispatchPlaceOrderProcessing,
    [CheckoutActionConstants.RESET_PLACE_ORDER_OBJ]: PlaceOrderRequestReducer.resetPlaceOrderObj,
}

/**
 * @description This constant contains the default values.
 * @type { payload: { soldTo: '', shipTo: '', userId: '', cardType: '', validTo: '', cardHolderName: '', cardToken: '', purchaseOrder: '', system: ''}}
 */
const initialState = {
    payload: {
        orderObj: {
            soldTo: '',
            shipTo: '',
            userId: '',
            paymentTerm:'',
            accountId:'',
            soldToAddressId:'',
            shipToAddressId:'',
            creditCard:
            {
                cardType: '',
                validTo: '',
                cardHolderName: '',
                cardToken: ''
            },
            purchaseOrder:
            {
                poNumber: '',
                poDate: '',
                poDocument: '',
                poFileName: '',
                poContentType: 'application/pdf'
            },
            system: '',
            emailIds: [''],
            products: []

        },
        orderReference: {
            status: '',
            id: '',
        },
        isOrderRequestInProgress: false,
    },
}

export const placeOrderRequestData = createReducer(initialState, handlers);
